<template>
  <div ref="infiniteScrollTrigger" style="min-height:1px;">
    <slot />
  </div>
</template>

<script setup>
import {onMounted, ref} from "vue";
import {handleInfiniteScroll} from "../helpers/HandleInfiniteScroll.js";

const emits = defineEmits(["trigger"]);

const infiniteScrollTrigger = ref(null);

onMounted(() => {
  handleInfiniteScroll(
    infiniteScrollTrigger.value,
    () => emits("trigger")
  );
});
</script>
